window._config = {
    rely: 'hzb',
    title: '惠招标·代理系统',
    title2: '惠招标',
    processType:'0',//1是横向流程  非1是纵向
    zbfileType:'hzb',
    // 登录
    loginBanner:'/web/index/information/getloginimg.json',//获取广告图接口
    dlloginad:'hzbloginad',//获取广告图  代理身份
    zbrloginad:'zbrloginad',//获取广告图  招标人身份
    qudong:'http://www.hbidding.com/pages/companyinfo/index.html?active=2',//驱动下载
    calc:'http://123.182.227.105:9999/tool/cahelp.pdf',//ca绑定流程
    zhuce:'http://www.hbidding.com/pages/register.html',//注册链接
    phoneNotUse:{
        mobanUrl:'http://www.hbidding.com/upload/Tools/findpasswordhelp.doc',
        emailAddress:'hb@zhbykj.com'
    },
    
    
}

import './scss/element-customize.scss'
import './scss/layout.scss'

require('../../src/main.js')